<div class="su-list-container">
  <ngx-spinner name="su-spinner" bdColor="rgba(0,0,0,0.3)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="color: white">Loading...</p>
  </ngx-spinner>

  <!-- Inline form -->
  <ng-container *ngIf="showForm">
    <app-system-update-form
      [update]="selectedUpdate"
      (saved)="onSaved()"
      (cancelled)="onCancelled()">
    </app-system-update-form>
  </ng-container>

  <!-- List view -->
  <ng-container *ngIf="!showForm">
    <div class="su-header d-flex align-items-center justify-content-between mb-4">
      <h4 class="mb-0">System Updates</h4>
      <button *ngIf="role === 'admin'" nbButton status="primary" size="small" (click)="openCreateForm()">
        <nb-icon icon="plus-outline" pack="eva"></nb-icon> New Update
      </button>
    </div>

    <div *ngIf="!loading && updates.length === 0" class="su-empty text-center py-5 text-muted">
      <nb-icon icon="bell-off-outline" pack="eva" style="font-size: 2.5rem;"></nb-icon>
      <p class="mt-3">No system updates yet.</p>
    </div>

    <div class="su-cards">
      <div class="card su-card mb-3" *ngFor="let update of updates">
        <div class="card-body">
          <div class="d-flex align-items-start justify-content-between gap-3">
            <div class="flex-grow-1">
              <div class="d-flex align-items-center gap-2 mb-1">
                <h5 class="mb-0">{{ update.title }}</h5>
                <span class="badge"
                  [ngClass]="update.state === 'planned' ? 'bg-primary text-white' : 'bg-success text-white'">
                  {{ update.state === 'planned' ? 'Planned' : 'Implemented' }}
                </span>
              </div>
              <small class="text-muted d-block mb-2">
                {{ update.createdAt | date:'dd MMM yyyy HH:mm' }}
              </small>
              <div class="su-body" [innerHTML]="update.body"></div>
            </div>
            <div *ngIf="role === 'admin'" class="su-actions d-flex gap-2 flex-shrink-0">
              <button nbButton ghost size="tiny" status="info" (click)="openEditForm(update)" title="Edit">
                <nb-icon icon="edit-2-outline" pack="eva"></nb-icon>
              </button>
              <button nbButton ghost size="tiny" status="danger" (click)="deleteUpdate(update._id)" title="Delete">
                <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
